import { render } from "./Assetparams.vue?vue&type=template&id=a21485a4&scoped=true"
import script from "./Assetparams.vue?vue&type=script&lang=js"
export * from "./Assetparams.vue?vue&type=script&lang=js"

import "./Assetparams.vue?vue&type=style&index=0&id=a21485a4&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21485a4"]])

export default __exports__